import * as React from 'react';
import type { ComponentType as ReactComponentT } from 'react';
import type { FormikHelpers } from 'formik';
import type { VisitorToken } from '@mentimeter/visitor/visitor-token';
import type { UtmTagsT } from '@mentimeter/utm';
import type { AllAuthClientT, AuthComponentBasePropsT } from '../types';

interface SubmitValuesT {
  email: string;
  password: string;
  name: string;
}

type handleSubmitT = (
  values: SubmitValuesT,
  formikActions: FormikHelpers<SubmitValuesT>,
) => any;

interface RenderPropsT {
  handleSubmit: handleSubmitT;
}

export interface PropsT extends AuthComponentBasePropsT, UtmTagsT {
  referral: string;
  render: (arg0: RenderPropsT) => any;
  setLoading: (isLoading: boolean) => void;
  visitorToken: VisitorToken | null;
  regionOverride?: 'eu' | 'us' | undefined;
  inviteToken?: string | undefined;
}

function createSignup(authClient: AllAuthClientT): ReactComponentT<PropsT> {
  class Signup extends React.Component<PropsT> {
    override render() {
      const {
        render,
        referral,
        utmFirst,
        utmLast,
        setLoading,
        onSuccess,
        onError,
        visitorToken,
        regionOverride,
        inviteToken,
      } = this.props;
      return render({
        handleSubmit: ({ email, password, name }, { setSubmitting }) => {
          const signupParams = {
            email,
            password,
            name,
            referral,
            utmFirst,
            utmLast,
            visitorToken,
            regionOverride,
            inviteToken,
          };
          setLoading(true);
          authClient
            .signup(signupParams)
            .then((res) => {
              setSubmitting(false);
              onSuccess(res);
            })
            .catch((e) => {
              setSubmitting(false);
              onError(e);
            });
        },
      });
    }
  }

  return Signup;
}

export default createSignup;
